export class MissingViteEnvError extends Error {
  public constructor(envVarName: string) {
    super(`${envVarName} variable is not defined`)
  }
}
